import styled from 'styled-components';

import { fontFamilyBase } from 'approot/shared/styles/typography.style';

/**
 * Scopes KaTeX overrides: match paragraph size (KaTeX defaults to ~1.21em) and use Calibre for
 * `\mathrm`, `\text`, etc.
 */
export const ContentPointBodyWrap = styled.span`
  /* Inline KaTeX is larger than body by default; inherit from teaching-notes Text (e.g. 16px). */
  .katex {
    font-size: inherit;
    font-family: ${fontFamilyBase} !important;
  }
`;
